import React, { useState } from "react";
import "./styles.css";
import logoSETDIG from "../../assets/img/logo-setdig-branca.svg";
import { useRef } from "react";
import { useHistory } from "react-router-dom";
import { SettingOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as AgendaAction from "../../redux/actions/agendaActions";
import * as ModalStatusAction from "../../redux/actions/modalStatus";
import {
  SolutionOutlined,
  UserOutlined,
  TeamOutlined,
  ApiOutlined,
} from "@ant-design/icons";

interface FooterProps {
  modalStatus?: any;
  setAgendamentos: any;
  removeAll: any;
}

const Footer: React.FC<FooterProps> = (props) => {
  const [menuUsuario, setMenuUsuario] = useState(true);
  const [aberto, setAberto] = useState(false);
  const history = useHistory();
  const divRodape = useRef<HTMLDivElement>(null);
  const divMenuId = useRef<HTMLDivElement>(null);
  const divSubMenuUsuario = useRef<HTMLDivElement>(null);
  var usuarioLogado = JSON.parse(
    sessionStorage.getItem("usuarioLogado") || "{}",
  );
  var geoEstruturaLogado = sessionStorage.getItem("geoEstrutura");
  var grupoLogado = sessionStorage.getItem("grupo");

  const onClickMenu = () => {
    let footer_height = divRodape.current?.clientHeight || 0;

    if (!aberto) {
      setAberto(true);
      footer_height = footer_height - 5;

      divMenuId.current!.style.marginBottom = footer_height + "px";
      divMenuId.current!.style.backgroundColor = "#343a40ff";
    } else {
      setAberto(false);
      divMenuId.current!.style.marginBottom = "-515px";
      divMenuId.current!.style.backgroundColor = "#343a4000";
    }
  };

  const renderMenus = (menus: any) => {
    menus = menus?.filter((m: any) => m.possuiMenu === true);

    return menus.map((item: any, index: number) => {
      return (
        <li id="item_menu" key={index} className="menuItemLi">
          <a
            className="link-menu"
            onClick={() => {
              history.push(`/${item.navegarURL}`);
            }}
          >
            <SettingOutlined className="icon" />
            <span>{item.nome}</span>
          </a>
        </li>
      );
    });
  };

  const setarHiddenMenuUsuario = () => {
    return new Promise<any>((resolve, reject) => {
      if (menuUsuario) {
        setMenuUsuario(false);
        resolve(menuUsuario);
      } else {
        setMenuUsuario(true);
        resolve(menuUsuario);
      }
    });
  };

  const scrollBaixo = (value: any) => {
    if (value) {
      divMenuId.current?.scrollTo(0, divMenuId.current.clientHeight);
    }
  };

  const logout = () => {
    props.removeAll();
    sessionStorage.clear();
    history.push(`/Login`);
  };

  return (
    <div className="agrupador">
      <div id="menuId" ref={divMenuId} className="menu_aberto">
        <div id="menu-item">
          <div id="right-colummn" className="menu">
            <div className="perfil">
              <ul id="menu-child-ul" className="perfil-info">
                <li id="item_perfil" key={10}>
                  <a
                    className="btn btn-success btn-perfil"
                    data-toggle="collapse"
                    onClick={() => {
                      setarHiddenMenuUsuario().then((response: any) => {
                        scrollBaixo(response);
                      });
                    }}
                  >
                    <UserOutlined className="icon" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div id="left-column" className="menu">
            <ul id="menu-child-ul" className="menu-child-ul menu-lista">
              {renderMenus(
                JSON.parse(sessionStorage.getItem("modulos") || "[]"),
              )}
              <li>
                <div
                  hidden={menuUsuario}
                  ref={divSubMenuUsuario}
                  id="submenu_perfil"
                  className="submenu collapse show"
                >
                  <ul id="submenu-child-ul" className="submenu-pefil-child-ul">
                    <li>
                      <span>{usuarioLogado.nomeUsuario}</span>
                    </li>
                    <li>
                      <SolutionOutlined className="icon" />
                      <span>
                        {" "}
                        {geoEstruturaLogado +
                          " / " +
                          (usuarioLogado.nomeDominio !== undefined
                            ? usuarioLogado.nomeDominio
                            : "")}
                      </span>
                    </li>
                    <li>
                      <TeamOutlined className="icon" />
                      <span> {grupoLogado}</span>
                    </li>
                    <li id="logoutItem">
                      <a
                        className="btn btn-outline-danger"
                        href="/#"
                        onClick={() => {
                          logout();
                        }}
                      >
                        <ApiOutlined className="icon" />
                        <span> Sair</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div id="rodape" ref={divRodape} className="rodape">
        <div id="rodape_menu">
          <div className="menu-btn">
            <button
              onClick={onClickMenu}
              type="button"
              id="my_menu"
              className="btn btn-info btn-menu"
            >
              <i className="fas fa-align-left"></i>
              <span>Menu</span>
            </button>
          </div>
        </div>
        <div className="logos-grid-logado">
          <div className="sgi-logo">
            <img src={logoSETDIG} alt="logoSetdig" className="sgi-logo-img" />
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state: any) => ({
  modalStatus: state.modalStatus,
  agenda: state.agendaReducer,
});

const mapDispatcToProps = (dispatch: any) =>
  bindActionCreators(
    Object.assign({}, ModalStatusAction, AgendaAction),
    dispatch,
  );

export default connect(mapStateToProps, mapDispatcToProps)(Footer);
